import React from 'react'
import { Route } from 'react-router-dom'
import RoutesWrapper from '../RoutesWrapper'

const Stage3 = React.lazy(
  () => import('../../pages/stages/stage3/Stage3Main'),
)
const Stage3Story = React.lazy(
  () => import('../../pages/stages/stage3/Stage3Story'),
)
const Stage3Ending = React.lazy(
  () => import('../../pages/stages/stage3/Stage3Ending'),
)

const loc = `stage3`

export const Stage3Routes = (
  <>
    <Route
      path="/stage3"
      element={
        <RoutesWrapper loc={loc}>
          <Stage3 />
        </RoutesWrapper>
      }
    />
    <Route
      path="/stage3/story"
      element={
        <RoutesWrapper loc={loc}>
          <Stage3Story />
        </RoutesWrapper>
      }
    />
    <Route
      path="/stage3/ending"
      element={
        <RoutesWrapper loc={loc}>
          <Stage3Ending />
        </RoutesWrapper>
      }
    />
  </>
)
